import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useNavigate } from "react-router-dom";

/**
 * Full-page message with a way back. Used when a page or record cannot be shown
 * (not found, no permission, or an unexpected error).
 */
export function ErrorPageView({ title, message, onHome, onBack }) {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, display: "flex", justifyContent: "center" }}>
      <Box sx={{ maxWidth: 520, textAlign: "center", px: 2 }}>
        <Box
          sx={{
            width: 72, height: 72, borderRadius: "50%", mx: "auto", mb: 2.5, display: "grid", placeItems: "center",
            background: "linear-gradient(135deg, #FEE2E2, #FDE68A)", color: "#B91C1C",
          }}
        >
          <ErrorOutlineRoundedIcon sx={{ fontSize: 38 }} />
        </Box>
        <Typography variant="h4" sx={{ mb: 1 }}>{title}</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
          <Button variant="contained" startIcon={<HomeRoundedIcon />} onClick={onHome}>Go to dashboard</Button>
          {onBack && <Button variant="outlined" onClick={onBack}>Go back</Button>}
        </Box>
      </Box>
    </Box>
  );
}

/** For use inside the router: picks wording from the HTTP status of an API error. */
export default function ErrorPage({ error, title, message }) {
  const navigate = useNavigate();
  const status = error?.response?.status;
  const heading =
    title ||
    (status === 404 ? "We couldn't find that"
      : status === 403 ? "You don't have access to that"
      : "Something went wrong");
  const text =
    message ||
    (status === 404
      ? "It may not exist, or it may belong to a different department. Switching department closes records from the previous one."
      : status === 403
      ? "Your role doesn't allow this. Ask an administrator if you think it should."
      : error?.response?.data?.message || error?.message || "An unexpected error occurred.");
  return (
    <ErrorPageView
      title={heading} message={text}
      onHome={() => navigate("/")} onBack={() => navigate(-1)}
    />
  );
}
